import { crud } from "../../../app/crud";
import { gSelector } from "../../../app/selector";
import { translate } from "../../../app/localisation";
import { selector } from "./selector";


const removeCardModal = function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    const $modal = $(gSelector.modal.deleteBs).modal('show');
    const url = $(e.target).closest('a').attr('href');

    $modal.find(gSelector.modal.success.general).html("").hide();
    $modal.find(gSelector.modal.errors.general).html("").hide();

    $modal.find('.js_btn_modal_confirm').off('click').on('click', function (ev) {
        crud.delete(url)
            .done(function (response) {
                $modal.find(gSelector.modal.success.general).html(response.message).show();
                $modal.modal('hide');
                window.location.reload();
            })
            .fail(function (response) {
                let errorsHtml = '';
                if (response.hasOwnProperty('responseJSON')) {
                    if (response.responseJSON.hasOwnProperty('errors')) {
                        let errors = response.responseJSON.errors;
                        for (let prop in errors) {
                            if (errors.hasOwnProperty(prop)) {
                                errorsHtml += '<div>' + errors[prop] + '</div>';
                            }
                        }
                    } else if (response.responseJSON.hasOwnProperty('generalError')) {
                        errorsHtml = response.responseJSON.generalError;
                    } else {
                        errorsHtml = translate('error_general');
                    }
                } else {
                    if ($.parseJSON(response.responseText)){
                        errorsHtml = $.parseJSON(response.responseText).generalError;
                    } else {
                        errorsHtml = translate('error_general');
                    }
                }
                $modal.find(gSelector.modal.errors.general).html(errorsHtml).show();
            });
    });
}

const setDefaultCard = function (e) {
    let cardId = parseInt($(this).attr('data'));
    const country = this.getAttribute('data-country');
   
    API.service.customer.setDefaultCard(cardId, country).done(function (response) {
        location.reload()
    })

}

export { removeCardModal, setDefaultCard };